import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as accountGeozoneActions from '../../actions/account_geozone/index';
import * as tagsActions from '../../actions/common/tags/index';
import * as datasourceActions from '../../actions/datasource/index';

/* Components */
import ModalCreate from '../../components/account_geozone/modalCreate';
import ModalEdit from '../../components/account_geozone/modalEdit';
import ModalDelete from '../../components/account_geozone/modalDelete';
import ModalActive from '../../components/account_geozone/modalActive';
import ModalDownload from '../../components/account_geozone/modalDownload';
import ModalUpdate from '../../components/account_geozone/modalUpdate';
import Header from '../../components/account_geozone/header';
import Table from '../../components/account_geozone/table';
import Title from '../../components/account_geozone/title';
import Mapa from '../../components/account_geozone/mapa';
import Buttons from '../../components/account_geozone/buttons';
import Text from '../../components/account_geozone/text';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class AccountGeozone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pag: 1,
      sort: true,
      select: false,
      modal: false,
      modalEdit: false,
      modalDelete: false,
      modalDownload: false,
      modalUpdate: false,
      modalActive: false,
      geozone: { a: true, b: false, c: false },
      polygon: false,
      taked: false,
      config: {
        name: '',
        code: '',
        id: '',
        polygon: '',
        ch: []
      }
    };
  }

  async componentDidMount() {
    /* Setting */
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('geozones');

    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('account')) {
          await this.props.datasourceActions.fetchDatasourceApi({});
          await this.props.actions.fetchAccountGeozoneChApi({});
          await this.props.actions.fetchAccountGeozoneApi({
            pag: this.state.pag,
            geozone: this.state.geozone
          });
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  componentWillUnmount() {
    this.props.actions.resetAccountGeozone();
  }

  handleGeozone = e => {
    e.preventDefault();
    const select = e.target.dataset.num;
    this.setState({ select: select });
  };

  handleSelect = async event => {
    const element = event.target;
    element.classList.toggle('select');
  };

  handleClickPoligon = num => {
    this.setState({ select: num });
  };

  handleModal = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modal ? false : true;
      this.setState({ modal: reset });
      if (!reset) {
        this.props.actions.resetModalGeozone();
        if (this.props.statusSave == 200) {
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountGeozoneApi({
            pag: this.state.pag,
            geozone: { a: true }
          });
        }
      }
    }
  };

  handleSort = async event => {
    const value = document.getElementById('search').value;
    const sort = this.state.sort ? false : true;
    await this.props.actions.fetchAccountGeozoneApi({ sort: sort, filter: value, geozone: this.state.geozone }, false);
    this.setState({ sort: this.state.sort ? false : true });
  };

  handleModalPoligon = async e => {
    const arr = e.layer._latlngs;
    let polygon = '';
    arr.forEach(item => {
      item.map((ll, i) => {
        if (i == 0) {
          polygon += `${ll.lat},${ll.lng}`;
        } else {
          polygon += `;${ll.lat},${ll.lng}`;
        }
      });
    });
    this.setState({
      modal: true,
      polygon: polygon
    });
  };

  handleSearch = async event => {
    if (!this.props.loading) {
      const value = event.target.value;
      this.setState({ pag: 1 });
      await this.props.actions.fetchAccountGeozoneApi(
        { sort: this.state.sort, filter: value, geozone: this.state.geozone },
        false
      );
    }
  };

  handleSubmit = async event => {
    const code = document.getElementById('code').value;
    const name = document.getElementById('name').value;
    const polygon = document.getElementById('geozone').value;
    const chArr = document.querySelectorAll('[data-ch]');
    const allRealDivsArray = Array.from(chArr);
    let ch = [];

    allRealDivsArray.forEach(item => {
      if (item.classList.contains('select')) {
        ch.push({ name: item.dataset.value, state: true });
      } else {
        ch.push({ name: item.dataset.value, state: false });
      }
    });
    const obj = {
      alias: name,
      code: code,
      polygon: polygon,
      features: ch
    };
    const arr = [obj];
    await this.props.actions.handleGeozone({ geozone: arr });
  };

  handleEditPoligon = async obj => {
    let polygon = '';
    const id = this.props.datos[obj.label].id;
    const code = this.props.datos[obj.label].code;
    const name = this.props.datos[obj.label].alias;
    const features = this.props.datos[obj.label].features;

    obj.ll.forEach(item => {
      item.map((ll, i) => {
        if (i == 0) {
          polygon += `${ll.lat},${ll.lng}`;
        } else {
          polygon += `;${ll.lat},${ll.lng}`;
        }
      });
    });

    const objs = {
      id: id,
      alias: name,
      code: code,
      polygon: polygon,
      features: features
    };
    const arr = [objs];
    await this.props.actions.handleUpdateGeozone({ geozone: arr });

    const value = document.getElementById('search').value;
    this.setState({ pag: 1 });
    this.props.actions.resetModalGeozone();
    await this.props.actions.fetchAccountGeozoneApi({ sort: this.state.sort, filter: value });
  };

  handleChange = e => {
    let config = { ...this.state.config };
    config[e.target.dataset.update] = e.target.value;
    this.setState({
      config
    });
  };

  handleModalEdit = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalEdit ? false : true;
      this.setState({ modalEdit: reset, taked: reset });
      if (!reset) {
        this.props.actions.resetModalGeozone();
        this.setState({
          config: {
            name: '',
            code: '',
            id: '',
            polygon: '',
            ch: []
          }
        });
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1 });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountGeozoneApi({
            pag: this.state.pag,
            geozone: { a: true }
          });
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        let polygon = '';
        const arrCh = [];
        obj.coordinates.forEach((item, i) => {
          if (i == 0) {
            polygon += `${item.latitude},${item.longitude}`;
          } else {
            polygon += `;${item.latitude},${item.longitude}`;
          }
        });
        obj.features.forEach(item => {
          arrCh.push(item);
        });

        this.setState({
          config: {
            id: obj.id,
            name: obj.alias,
            code: obj.code,
            polygon: polygon,
            ch: arrCh
          }
        });
      }
    }
  };

  handleUpdate = async event => {
    const code = document.getElementById('codeup').value;
    const name = document.getElementById('nameup').value;
    const id = document.getElementById('id').value;
    const polygon = document.getElementById('polygon').value;
    const chArr = document.querySelectorAll('[data-chup]');
    const allRealDivsArray = Array.from(chArr);
    let ch = [];
    allRealDivsArray.forEach(item => {
      if (item.classList.contains('select')) {
        ch.push({ name: item.dataset.value, state: true });
      } else {
        ch.push({ name: item.dataset.value, state: false });
      }
    });

    const obj = {
      id: id,
      alias: name,
      code: code,
      polygon: polygon,
      features: ch
    };
    const arr = [obj];
    await this.props.actions.handleUpdateGeozone({ geozone: arr });
  };

  handleDelete = async event => {
    const code = document.getElementById('iddelete').value;
    await this.props.actions.handleDeleteGeozone({ id: code });
  };

  handleModalDelete = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDelete ? false : true;
      this.setState({ modalDelete: reset });
      if (!reset) {
        this.props.actions.resetModalGeozone();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1 });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountGeozoneApi({
            pag: this.state.pag,
            geozone: { a: true }
          });
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        this.setState({
          config: {
            id: obj.id,
            name: obj.alias,
            code: obj.code,
            ch: []
          }
        });
      }
    }
  };

  handleModalActive = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalActive ? false : true;
      this.setState({ modalActive: reset });
      if (!reset) {
        this.props.actions.resetModalGeozone();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1 });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountGeozoneApi({
            pag: this.state.pag,
            geozone: { a: true }
          });
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        this.setState({
          config: {
            id: obj.id,
            name: obj.alias,
            code: obj.code,
            ch: []
          }
        });
      }
    }
  };

  handleModalDownload = async e => {
    e.preventDefault();
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDownload ? false : true;
      this.setState({ modalDownload: reset });
    }
  };

  handleDownload = async e => {
    await this.props.actions.fetchAccountGeozoneDownloadApi();
    this.props.actions.resetModalFileGeozoneAccount();
    this.setState({ modalDownload: false });
  };

  handleModalUpdate = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalUpdate ? false : true;
      this.setState({ modalUpdate: reset });
      if (!reset) {
        if (this.props.statusFile == 200) {
          document.getElementById('search').value = '';
          this.setState({ pag: 1 });
          await this.props.actions.fetchAccountGeozoneApi({ pag: 1, geozone: { a: true } });
        }
        this.props.actions.resetModalFileGeozoneAccount();
        if (this.props.statusFile == null) {
          document.getElementById('file-error').classList.add('none');
          document.getElementById('file').value = '';
          document.getElementById('file-1').innerHTML = '';
          document.getElementById('btn-upload').classList.remove('active');
        }
      }
    }
  };

  handleUploadValue = async e => {
    const fullPath = document.getElementById('file').value;
    const btnUpload = document.getElementById('btn-upload');
    let extensionArr = fullPath.split('.');
    extensionArr = extensionArr[extensionArr.length - 1];
    if (
      (fullPath !== '' && extensionArr.toLowerCase() === 'xlsx') ||
      extensionArr.toLowerCase() === 'xls'
    ) {
      btnUpload.classList.add('active');
      document.getElementById('file-error').classList.add('none');
    } else {
      btnUpload.classList.remove('active');
      if (fullPath !== '') {
        document.getElementById('file-error').classList.remove('none');
      } else {
        document.getElementById('file-error').classList.add('none');
      }
    }
    document.getElementById('file-1').innerHTML = fullPath;
  };

  handleUpload = async e => {
    const btnUpload = document.getElementById('btn-upload');
    if (btnUpload.classList.contains('active')) {
      const fullPath = document.getElementById('file').files;
      await this.props.actions.fetchAccountGeozoneUploadApi({});
    }
  };

  handleGeozoneFilter = async event => {
    const select = event.target.dataset.select;
    document.getElementById('select-filter').innerHTML = `<span>Mostrar:</span><div>${event.target.innerHTML}</div>`;
    const value = document.getElementById('search').value;
    let obj = {};
    if (select == 'a') {
      this.setState({ geozone: { a: false, b: false, c: true } });
      obj = { a: false, b: false, c: true };
    } else if (select == 'b') {
      this.setState({ geozone: { a: false, b: true, c: false } });
      obj = { a: false, b: true, c: false };
    } else if (select == 'c') {
      this.setState({ geozone: { a: true, b: false, c: false } });
      obj = { a: true, b: false, c: false };
    }
    await this.props.actions.fetchAccountGeozoneNoLoadingApi({
      filter: value,
      sort: this.state.sort,
      concat: false,
      geozone: obj
    });
  };

  handleActive = async event => {
    const code = document.getElementById('idactive').value;
    await this.props.actions.handleActiveGeozone({ id: code });
  };

  render() {
    const button = localStoreFN().getItem('permits');
    const buttonShow = button.includes('geozonescrud');

    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const language = this.props.language ? this.props.language.filter : '';
      return (
        <section className="main">
          <Header handleSearch={this.handleSearch} language={language} />
          <div className="main-container">
            {this.props.loading || this.props.loadingDatasource ? (
              <Loading language={this.props.language} />
            ) : this.props.status === 401 || this.props.statusDatasource === 401 ? (
              <Expired
                history={this.props.history}
                language={this.props.language ? this.props.language : ''}
              />
            ) : this.props.status === 200 && this.props.statusDatasource === 200 ? (
              <div className="main-container">
                <ModalCreate
                  handleSelect={this.handleSelect}
                  handleSubmit={this.handleSubmit}
                  handleModal={this.handleModal}
                  modal={this.state.modal}
                  polygon={this.state.polygon}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  characteristic={this.props.datosCh}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalEdit
                  handleSelect={this.handleSelect}
                  handleChange={this.handleChange}
                  handleSubmit={this.handleUpdate}
                  handleModal={this.handleModalEdit}
                  modal={this.state.modalEdit}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  characteristic={this.props.datosCh}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalDelete
                  handleSubmit={this.handleDelete}
                  handleModal={this.handleModalDelete}
                  modal={this.state.modalDelete}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalActive
                  handleSubmit={this.handleActive}
                  handleModal={this.handleModalActive}
                  modal={this.state.modalActive}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalDownload
                  handleModal={this.handleModalDownload}
                  modal={this.state.modalDownload}
                  handleDownload={this.handleDownload}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalUpdate
                  handleDownload={this.handleDownload}
                  handleUpload={this.handleUpload}
                  handleUploadValue={this.handleUploadValue}
                  handleModal={this.handleModalUpdate}
                  modal={this.state.modalUpdate}
                  datos={this.props.datosFile}
                  loading={this.props.loadingFile}
                  status={this.props.statusFile}
                  language={this.props.language ? this.props.language : ''}
                />
                <div className="module-geozone">
                  <div className="box-geozone-a">
                    {buttonShow && (
                      <Text language={this.props.language ? this.props.language : ''} />
                    )}
                    {buttonShow && (
                      <Title language={this.props.language ? this.props.language : ''} />
                    )}
                    <Buttons
                      buttonShow={buttonShow}
                      handleModalUpdate={this.handleModalUpdate}
                      handleModalDownload={this.handleModalDownload}
                      handleGeozoneFilter={this.handleGeozoneFilter}
                      language={this.props.language ? this.props.language : ''}
                    />
                    <Table
                      buttonShow={buttonShow}
                      handleGeozone={this.handleGeozone}
                      handleSort={this.handleSort}
                      pag={this.state.pag}
                      count={this.props.count}
                      loadingTable={this.props.loadingTable}
                      datos={this.props.datos}
                      handleModal={this.handleModalEdit}
                      handleModalDelete={this.handleModalDelete}
                      handleModalActive={this.handleModalActive}
                      language={this.props.language ? this.props.language : ''}
                    />
                  </div>
                  <div className="box-geozone-b">
                    <Mapa
                      buttonShow={buttonShow}
                      handleModalPoligon={this.handleModalPoligon}
                      handleClickPoligon={this.handleClickPoligon}
                      select={this.state.select}
                      map={this.props.map}
                      datos={this.props.datos}
                      handleEditPoligon={this.handleEditPoligon}
                      taked={this.state.taked}
                      loadingSave={this.props.loadingSave}
                      language={this.props.language ? this.props.language : ''}
                    />
                  </div>
                </div>
              </div>
            ) : this.props.status === 500 || this.props.statusDatasource === 500 ? (
              <Message message={this.props.language.error.apiError500} />
            ) : (
              <Message message={this.props.language.error.apiError} />
            )}
          </div>
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}
const mapStateToProps = state => ({
  datosDatasource: state.reducer.datasource.datos,
  loadingDatasource: state.reducer.datasource.loading,
  statusDatasource: state.reducer.datasource.status,

  setting: state.reducer.dashboard.setting,

  datos: state.reducer.accountGeozone.datos,
  loading: state.reducer.accountGeozone.loading,
  status: state.reducer.accountGeozone.status,
  map: state.reducer.accountGeozone.map,
  language: state.reducer.dashboard.language,
  loadingSave: state.reducer.accountGeozone.loadingSave,
  statusSave: state.reducer.accountGeozone.statusSave,
  dataSave: state.reducer.accountGeozone.dataSave,

  datosCh: state.reducer.accountGeozone.datosCh,

  datosFile: state.reducer.accountGeozone.datosFile,
  loadingFile: state.reducer.accountGeozone.loadingFile,
  statusFile: state.reducer.accountGeozone.statusFile
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(accountGeozoneActions, dispatch),
  tagsActions: bindActionCreators(tagsActions, dispatch),
  datasourceActions: bindActionCreators(datasourceActions, dispatch)
});
AccountGeozone.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountGeozone);



// WEBPACK FOOTER //
// ./source/client/containers/account_geozone/index.jsx